<template>
    <ThePage :class-name="'TableView'"
             :title="'TABLE__TABLE'">
        <template slot="left-action">
            <!--BACK-->
            <BaseNavigationButton :icon="'icon-left'"
                                  @click="back()" />
        </template>
        <TheTableSearch />
        <TheTablePaging />
        <div class="TableView__content" v-show="isLoaded">
            <table class="TableView__table" v-show="items.length>0">
                <thead class="TableView__head">
                    <!--HEADER-->
                    <tr class="TableView__head-row">
                        <th class="TableView__head-cell" @click="setOrder('name')">
                            <span>{{translate('TABLE__NAME')}}</span>
                            <span v-if="sortByColumn('name')">
                                <i v-if="isAsc" class="icon-up-dir"></i>
                                <i v-else class="icon-down-dir"></i>
                            </span>
                        </th>
                        <th class="TableView__head-cell" @click="setOrder('phone')">
                            <span>{{translate('TABLE__PHONE')}}</span>
                            <span v-if="sortByColumn('phone')">
                                <i v-if="isAsc" class="icon-up-dir"></i>
                                <i v-else class="icon-down-dir"></i>
                            </span>
                        </th>
                        <th class="TableView__head-cell" @click="setOrder('company')">
                            <span>{{translate('TABLE__COMPANY')}}</span>
                            <span v-if="sortByColumn('company')">
                                <i v-if="isAsc" class="icon-up-dir"></i>
                                <i v-else class="icon-down-dir"></i>
                            </span>
                        </th>
                        <th class="TableView__head-cell" @click="setOrder('city')">
                            <span>{{translate('TABLE__CITY')}}</span>
                            <span v-if="sortByColumn('city')">
                                <i v-if="isAsc" class="icon-up-dir"></i>
                                <i v-else class="icon-down-dir"></i>
                            </span>
                        </th>
                    </tr>
                </thead>
                <!--ROWS-->
                <tbody class="TableView__body">
                    <tr v-for="(item, index) in items" :key="item.id" class="TableView__row">
                        <td class="TableView__cell">
                            <div class="TableView__cell-title" @click="setOrder('name')">
                                <span>{{translate('TABLE__NAME')}}</span>
                                <span v-if="sortByColumn('name')">
                                    <i v-if="isAsc" class="icon-up-dir"></i>
                                    <i v-else class="icon-down-dir"></i>
                                </span>
                            </div>
                            <div class="TableView__cell-content">
                                {{item.name}}
                            </div>
                        </td>
                        <td class="TableView__cell">
                            <div class="TableView__cell-title" @click="setOrder('phone')">
                                <span>{{translate('TABLE__PHONE')}}</span>
                                <span v-if="sortByColumn('phone')">
                                    <i v-if="isAsc" class="icon-up-dir"></i>
                                    <i v-else class="icon-down-dir"></i>
                                </span>
                            </div>
                            <div class="TableView__cell-content">
                                {{item.phone}}
                            </div>
                        </td>
                        <td class="TableView__cell">
                            <div class="TableView__cell-title" @click="setOrder('company')">
                                <span>{{translate('TABLE__COMPANY')}}</span>
                                <span v-if="sortByColumn('company')">
                                    <i v-if="isAsc" class="icon-up-dir"></i>
                                    <i v-else class="icon-down-dir"></i>
                                </span>
                            </div>
                            <div class="TableView__cell-content">
                                {{item.company}}
                            </div>
                        </td>
                        <td class="TableView__cell">
                            <div class="TableView__cell-title" @click="setOrder('city')">
                                <span>{{translate('TABLE__CITY')}}</span>
                                <span v-if="sortByColumn('city')">
                                    <i v-if="isAsc" class="icon-up-dir"></i>
                                    <i v-else class="icon-down-dir"></i>
                                </span>
                            </div>
                            <div class="TableView__cell-content">
                                {{item.city}}
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <BaseLoader v-show="!isLoaded" />
    </ThePage>
</template>

<script>
    import { mapState, mapActions, mapGetters  } from 'vuex';
    import ThePage from '../components/common/ThePage.vue';
    import BaseNavigationButton from '../components/common/BaseNavigationButton.vue';
    import BaseLoader from '../components/common/BaseLoader.vue';
    import TheTableSearch from '../components/table/TheTableSearch.vue';
    import TheTablePaging from '../components/table/TheTablePaging.vue';

    export default {
        name: 'TableView',
        components: {
            ThePage,
            BaseNavigationButton,
            BaseLoader,
            TheTableSearch,
            TheTablePaging
        },
        beforeRouteEnter(to, from, next) {
            next(vm => {
                vm.open();
            });
        },
        computed: {
            ...mapState({
                items: s => s.table.items,
                isLoaded: s => s.table.isLoaded,
                isAsc: s => s.table.order.charAt(0) !== '-'
            }),
            ...mapGetters({
                sortByColumn: 'table/sortByColumn'
            })
        },
        methods: {
            ...mapActions({
                open: 'table/open',
                setOrder: 'table/setOrder',
                back: 'table/back'
            })
        }
    };
</script>

<style>
    .TableView {
        min-width: 100%;
        min-height: 100vh;
        display: flex;
        flex-direction: column;
        background: #b0bec5;
        background: radial-gradient(ellipse at center,#eceff1 0,#90a4ae 100%)
    }

    .TableView__content {
        position: relative;
        padding: 8px;
    }

    .TableView__table {
        width: 100%;
        overflow-y: auto;
        display: table;
        box-shadow: 0 1px 3px 0 rgba(0,0,0,.12), 0 1px 2px 0 rgba(0,0,0,.24);
        border-radius: 2px;
        background-color: #fff;
    }

    .TableView__head {
    }

    .TableView__head-row {
    }

    .TableView__head-cell {
        text-align: left;
        padding: 8px;
        font-weight: normal;
        color: rgba(0, 0, 0, 0.5);
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        font-size: 12px;
        cursor: pointer;
        user-select: none;
    }

    .TableView__body {
    }

    .TableView__row {
    }

    .TableView__cell {
        text-align: left;
        padding: 8px;
    }

    .TableView__cell-title {
        display: none;
        cursor: pointer;
        user-select: none;
    }

    .TableView__cell-content {
        font-weight: 500;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        display: flex;
    }

    .TableView__link {
        color: #00bcd4;
        font-weight: 500;
        cursor: pointer;
        text-decoration: underline;
    }

        .TableView__link:hover {
            color: #00838F;
        }

    @media (max-width: 767px) {

        .TableView__table {
            background-color: transparent;
            box-shadow: none;
            border-radius: 0;
            overflow: visible;
        }

        .TableView__head {
            display: none;
        }

        .TableView__body {
            display: flex;
            flex: 1 1 auto;
            flex-direction: column;
            align-items: stretch;
        }

        .TableView__row {
            display: flex;
            flex-direction: column;
            box-shadow: 0 1px 3px 0 rgba(0,0,0,.12), 0 1px 2px 0 rgba(0,0,0,.24);
            border-radius: 2px;
            background-color: #fff;
            margin-top: 8px;
        }

            .TableView__row:first-child {
                margin-top: 0px;
            }

        .TableView__cell-title {
            display: flex;
            color: rgba(0,0,0,0.5);
        }
    }

    @media (max-width: 767px) and (min-width: 385px) {
        .TableView__cell {
            flex: auto;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
        }
    }

    @media (max-width: 384px) {
        .TableView__cell {
            flex: auto;
            display: flex;
            flex-direction: column;
        }

        .TableView__cell-title {
            padding: 2px;
            font-size: 12px;
        }

        .TableView__cell-content {
            padding: 2px;
        }
    }
</style>



// WEBPACK FOOTER //
// TableView.vue?23796021